/** 手机使用要求：记录按字段阅读，金额/薪资对比保留横向表；弹窗表单可换行、主要操作便于触控。只调整显示，不改变数据、权限及审批规则。 */
import React, { useState } from "react";
import { Eye, EyeOff, FileText, Loader2, ExternalLink } from "lucide-react";
import { toast } from "../../../components/ui/sonner";

/* HR 入职表详情 / 员工档案「入职数据」共用：脱敏字段 + 揭示（留审计）+ PDF / 证件打开 */
export async function openBlob(api, url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(new Blob([res.data], { type: res.headers["content-type"] || "application/pdf" }));
  const a = document.createElement("a"); a.href = blobUrl; a.target = "_blank"; a.rel = "noreferrer"; if (filename && !/pdf|image/.test(res.headers["content-type"] || "")) a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}

export function Reveal({ api, url, field, masked, canReveal, zh, testid }) {
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    if (val) return setVal("");
    setBusy(true);
    try { const { data } = await api.post(url, { field }); setVal(data.value); setTimeout(() => setVal(""), 30000); }
    catch (e) { toast.error(e?.response?.data?.detail || (zh ? "无法查看" : "Cannot reveal")); }
    setBusy(false);
  };
  return (
    <span className="inline-flex items-center gap-1.5 font-mono" data-testid={testid}>
      <span data-testid={`${testid}-value`}>{val || masked || "—"}</span>
      {canReveal && masked && <button type="button" data-testid={`${testid}-toggle`} onClick={toggle} title={zh ? "查看完整（记录审计）" : "Reveal (audited)"} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 text-slate-400 hover:text-red-600">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : val ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}</button>}
    </span>
  );
}

export function KV({ k, v, testid }) {
  return <div className="flex gap-2 text-[12px]" data-testid={testid}><span className="text-slate-400 w-36 flex-shrink-0">{k}</span><span className="text-slate-800 break-words min-w-0">{v ?? "—"}</span></div>;
}

export function DocLink({ api, url, label, testid }) {
  const [busy, setBusy] = useState(false);
  return (
    <button type="button" data-testid={testid} disabled={busy} onClick={async () => { setBusy(true); try { await openBlob(api, url); } catch { toast.error("打开失败"); } setBusy(false); }}
      className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 inline-flex items-center gap-1 text-[11.5px] rounded-full border border-slate-300 bg-white text-slate-700 hover:border-red-400 px-2.5 py-1 disabled:opacity-50">
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <FileText className="h-3 w-3 text-red-500" />}{label}<ExternalLink className="h-3 w-3 text-slate-400" />
    </button>
  );
}

export const W4_FS = { single: "Single / MFS", mfj: "Married filing jointly", hoh: "Head of household" };
export const DE4_FS = { single: "Single / dual-income", married: "Married (one income)", hoh: "Head of household" };
export const CZ = { citizen: "U.S. citizen", noncitizen_national: "Noncitizen national", lpr: "Lawful permanent resident", alien_authorized: "Noncitizen authorized to work" };
export const PDF_LABEL = { w4: "W-4 (signed)", de4: "DE-4 (signed)", i9: "I-9 Section 1 (signed)", i9_complete: "I-9 complete (Section 1 + 2)", summary: "Onboarding summary" };
